"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: t, size: c = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = s(), e = t !== null && t !== void 0 ? t : a ? l.colors.inverse : l.colors.neutralHigh, { skinName: i } = n();
    return i.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M16.53 22a3.43 3.43 0 0 1-2.459-1.043L3.89 10.506A5 5 0 0 1 2.47 6.98c0-1.33.505-2.58 1.42-3.523a4.772 4.772 0 0 1 6.864 0l10.553 10.825c.28.288.28.755 0 1.043a.705.705 0 0 1-1.015 0L9.738 4.5a3.34 3.34 0 0 0-2.416-1.028c-.915 0-1.77.363-2.417 1.028a3.52 3.52 0 0 0-1.002 2.481c0 .939.354 1.816 1.002 2.481l10.181 10.453c.795.816 2.09.816 2.886 0a2.14 2.14 0 0 0 0-2.962L7.79 6.505a.665.665 0 0 0-.932 0 .68.68 0 0 0-.193.48c0 .185.069.355.193.482l9.203 9.448c.28.288.28.755 0 1.043a.705.705 0 0 1-1.016 0L5.842 8.505a2.193 2.193 0 0 1 0-3.043 2.06 2.06 0 0 1 2.968 0l10.182 10.453c1.355 1.392 1.355 3.656 0 5.043A3.46 3.46 0 0 1 16.529 22"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M11.993 21.841c-2.863 0-4.507-1.563-4.507-4.291V5.31c0-2.004 1.207-3.155 3.31-3.155 2.104 0 3.311 1.148 3.311 3.154l.026 11.053c0 1.166-.76 1.888-1.98 1.888-1.222 0-1.981-.723-1.981-1.885V6.284c0-.34.288-.61.641-.61.356 0 .642.274.642.61v10.078c0 .496.176.661.694.661.522 0 .695-.165.695-.66l-.028-11.054c0-1.316-.644-1.93-2.025-1.93s-2.025.614-2.025 1.93V17.55c0 2.064 1.053 3.067 3.221 3.067s3.221-1.003 3.221-3.067l.011-11.32c0-.338.289-.61.642-.61.356 0 .641.274.641.613l-.01 11.32c.008 2.725-1.637 4.288-4.5 4.288"
        })
    }));
}, u = h;
export { u as default };
